import { classes, selectors } from './init';

export const hideAnchorNav = (el: HTMLElement): void => {
	el.classList.remove(classes.show);
	el.classList.add(classes.hide);
	disableActiveNavItem();
};

export const showAnchorNav = (el: HTMLElement): void => {
	el.classList.remove(classes.hide);
	el.classList.add(classes.show);
};

export const disableActiveNavItem = (): void => {
	const activeItem = document.querySelector(selectors.activeItem);
	if (activeItem) activeItem.classList.remove(classes.active);
};

export const enableNavItem = (item: HTMLElement): void => {
	// Continue if current nav item is not already active
	if (!item.classList.contains('active')) {
		// Remove active state from other possible item
		disableActiveNavItem();

		// Add active state to current nav item
		item.classList.add(classes.active);
	}
};

export const setAnchorNavItemVisibility = (container: HTMLElement): void => {
	container.querySelectorAll<HTMLElement>(selectors.item).forEach((el) => {
		const target = el.getAttribute('data-target');
		const section = target ? document.getElementById(target) : null;
		el.hidden = !section?.checkVisibility();
	});
};

export const getAnchors = (container: HTMLElement): HTMLElement[] => {
	const anchors: HTMLElement[] = [];

	container.querySelectorAll<HTMLElement>(selectors.item).forEach((el) => {
		const target = el.getAttribute('data-target');
		const section = target ? document.getElementById(target) : null;
		if (section) {
			anchors.push(section);
		}
	});

	return anchors;
};
